import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import Login from "../src/components/login/login.tsx";
import Dashboard from "../src/components/dashboard/dashboard.tsx";
import Employee from "../src/components/employee_portal/employee.tsx";
import ProtectedRoute from "./components/ProtectedRoute.tsx";
import { useEffect } from "react";
import Products from "./components/products/products.tsx";
import TrackOrders from "./components/track_orders/track_orders.tsx";
import TotalUserCount from "./components/total_user_count/total_user_count.tsx";

function App() {
  return (
    <div className="App">
      <Router>
        <AppContent />{" "}
        {/* Move the logic that uses useNavigate into a child component */}
      </Router>
    </div>
  );
}

function AppContent() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (token && window.location.pathname === "/") {
      navigate("/dashboard");
    }
  }, [token, navigate, window.location.pathname]);

  return (
    <Routes>
      <Route path="*" element={<Dashboard />} />
      <Route path="/" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/employee-portal"
        element={
          <ProtectedRoute>
            <Employee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products"
        element={
          <ProtectedRoute>
            <Products />
          </ProtectedRoute>
        }
      />
      <Route
        path="/track-orders"
        element={
          <ProtectedRoute>
            <TrackOrders />
          </ProtectedRoute>
        }
      />
      <Route
        path="/total-users"
        element={
          <ProtectedRoute>
            <TotalUserCount />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
